import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {getElevatorDetails, openModal} from '../actions';
import {Layout, PageHeader} from '../components';
import ElevatorModal from '../components/Modals/ElevatorModal';

const ElevatorsDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {id} = useParams();
  const {user} = useSelector(s => s.user);
  const {elevatorById} = useSelector(s => s.elevators);

  const onBack = () => {
    navigate(-1);
  };
  const configureElevator = () => {
    navigate(`/elevators/${id}/configure`);
  };
  const onDelete = () => {
    dispatch(openModal('DeleteModal', {type: 'elevator', item: elevatorById}));
  };

  useEffect(() => {
    dispatch(getElevatorDetails(id));
  }, []);

  return (
    <Layout>
      <PageHeader onBack={onBack} onDelete={!!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' && !!elevatorById && onDelete} />
      {!!elevatorById && (
        <ElevatorModal
          elevatorToEdit={elevatorById}
          configureElevator={configureElevator}
        />
      )}
    </Layout>
  );
};

export default ElevatorsDetails;
